export default __webpack_public_path__ + "static/tracker-51d6166da8e6a913bcea11282425aa73.png";